module.exports = __webpack_public_path__ + "media/images/lb/171-214955d957f275a60e570a67ff241c6a.svg";